import { render, staticRenderFns } from "./XunjiaGoodsDetail.vue?vue&type=template&id=d2e91264&scoped=true"
import script from "./XunjiaGoodsDetail.vue?vue&type=script&lang=js"
export * from "./XunjiaGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./XunjiaGoodsDetail.vue?vue&type=style&index=0&id=d2e91264&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e91264",
  null
  
)

export default component.exports